import {useState, type FC} from "react"
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material"
import {DoneIcon} from "../../../assets"

type Props = {
  onCheckboxChange: (state: {[key: string]: boolean}) => void
}

const ExpertSearchFilter: FC<Props> = ({onCheckboxChange, ...props}) => {
  const checkboxItems = [
    {name: "Americas", label: "Americas"},
    {name: "APAC", label: "APAC"},
    {name: "EMEA", label: "EMEA"},
  ]
  const [state, setState] = useState<{[key: string]: boolean}>({
    Americas: false,
    APAC: false,
    EMEA: false,
  })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newState = {
      ...state,
      [event.target.name]: event.target.checked,
    }
    setState(newState)
    onCheckboxChange(newState)
  }

  return (
    <Box
      id="moleculeExpertSearchFilter"
      style={{
        margin: "8px 24px 8px 24px",
      }}
    >
      <FormControl component="fieldset" variant="standard">
        <FormLabel
          component="legend"
          style={{
            color: "#053747",
            fontSize: "16px",
            fontFamily: "Open Sans",
            lineHeight: "24px",
            marginBottom: "4px",
          }}
        >
          Region
        </FormLabel>
        <FormGroup
          sx={{
            flexDirection: "row",
          }}
        >
          {checkboxItems.map((item) => (
            <FormControlLabel
              id={`expertSearchFormLabel${item.name}`}
              key={item.name}
              sx={{
                color: "#242d35",
                fontFamily: "Open Sans",
                fontSize: "16px",
                height: "32px",
                padding: "4px 16px 4px 16px",
                "& .css-1xlflnz-MuiButtonBase-root-MuiCheckbox-root:hover": {
                  backgroundColor: "transparent",
                },
              }}
              control={
                <Checkbox
                  id={`expertSearchCheckbox${item.name}`}
                  disableRipple
                  checked={state[item.name]}
                  onChange={handleChange}
                  name={item.name}
                  icon={
                    <div
                      style={{
                        height: "16px",
                        width: "16px",
                        border: "solid 0.8px #053747",
                        borderRadius: "3px",
                        backgroundColor: "#fff",
                      }}
                    ></div>
                  }
                  checkedIcon={
                    <div
                      style={{
                        height: "16px",
                        width: "16px",
                        borderRadius: "3px",
                        border: "solid 0.8px #003d50",
                        backgroundColor: "#003d50",
                        fontSize: "10px",
                      }}
                    >
                      <DoneIcon />
                    </div>
                  }
                ></Checkbox>
              }
              label={item.label}
            />
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  )
}

export default ExpertSearchFilter
